export default "__VITE_ASSET__DmLb8d7$__"